import { FormattedNumber, useIntl } from 'react-intl';

import SideTab from 'components/side-tab';

import DailyConsumptionRateTab from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/components/input-settings/daily-consumption/daily-consumption-rate-tab';
import FeedInventoryTab from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/components/input-settings/feed-inventory/feed-inventory-tab';
import FeedReserveTab from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/components/input-settings/feed-reserve/feed-reserve-tab';
import PreferencesTab from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/components/input-settings/preferences/preferences-tab';
import OfdSettingsFallback from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/components/ofd-settings-fallback';
import { useInputSettingsState } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/context/input-settings-context';
import { bufferKgValue } from 'views/order-feed/features/my-supply-plan/features/ofd-2.0/utils/feed-reserve-calculations';
import { Box, Grid } from '@mui/material';

type Props = {};

const InputSettings: React.FC<Props> = ({ }) => {
  const intl = useIntl();
  const PAGE_NAME_ID = 'orderFeed.ofdMySupplyPlan.inputSettings';
  const {
    getOfdSettingsQuery: { data: ofdSettings },
  } = useInputSettingsState();

  const days = ofdSettings?.consumptionBufferDays ?? 0;
  const dailyConsumptionRate = ofdSettings?.currentConsumptionRate ?? 0;
  const bufferValue = ofdSettings?.capacityBuffer ?? 0;
  const maxSiloCapacity = ofdSettings?.siloCapacity ?? 0;

  const startingInventory = ofdSettings?.inventoryExplanation?.startingInventory ?? 0;
  const staticBufferKg = bufferKgValue(maxSiloCapacity, bufferValue);
  const showConsumptionsKgDays = dailyConsumptionRate * days;
  const totalBuffer = Number(staticBufferKg) + Number(showConsumptionsKgDays);

  return (
    <OfdSettingsFallback minHeight={260}>
      <Grid container gap={4}>
        <Grid size={12}>
          <Box>
            <SideTab
              tabs={[
                {
                  value: 'Feed inventory',
                  label: intl.formatMessage({ id: `${PAGE_NAME_ID}.feedInventoryTab.label` }),
                  valueLabel: (
                    <FormattedNumber
                      value={startingInventory}
                      unit={'kilogram'}
                      style="unit"
                      minimumFractionDigits={0}
                      maximumFractionDigits={0}
                    />
                  ),
                  content: <FeedInventoryTab />,
                },
                {
                  value: 'Daily Consumption Rate',
                  label: intl.formatMessage({ id: `${PAGE_NAME_ID}.dailyConsumptionRateTab.label` }),
                  valueLabel: (
                    <FormattedNumber
                      value={ofdSettings?.currentConsumptionRate ?? 0}
                      unit={'kilogram'}
                      style="unit"
                      minimumFractionDigits={0}
                      maximumFractionDigits={0}
                    />
                  ),
                  content: <DailyConsumptionRateTab />,
                },
                {
                  value: 'Feed Reserve',
                  label: intl.formatMessage({ id: `${PAGE_NAME_ID}.feedReserveTab.label` }),
                  valueLabel: (
                    <FormattedNumber
                      value={totalBuffer}
                      unit={'kilogram'}
                      style="unit"
                      minimumFractionDigits={0}
                      maximumFractionDigits={0}
                    />
                  ),
                  content: <FeedReserveTab bufferValue={0} />,
                },
                {
                  value: 'Preferences',
                  label: intl.formatMessage({ id: `${PAGE_NAME_ID}.preferencesTab.label` }),
                  content: <PreferencesTab />,
                },
              ]}
            />
          </Box>
        </Grid>
      </Grid>
    </OfdSettingsFallback>
  );
};

export default InputSettings;
